import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const arjCalendarEmbedRoute: InvariantJiraRoute = {
	name: 'software-plan-calendar-embed',
	path: '/jira/plans/:planId/scenarios/:scenarioId/calendar/embed',
};
